import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodDeleteContractAttachmentEndpointSchema } from './validations';

/**
 * Deletes a contract attachment by its ID.
 *
 * @param contractId - The ID of the contract the attachment belongs to.
 * @param attachmentId - The ID of the attachment to delete.
 * @param options - Optional request options (e.g., abort signal).
 * @returns A promise that resolves when the attachment is deleted.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/delete_attachment_contracts__contract_id__attachments__att_id__delete
 */
export const deleteContractAttachment = async (
  contractId: UUID,
  attachmentId: UUID,
  options?: KyRequestOptions,
) => {
  await vestigasApi.delete(
    ENDPOINT.CONTRACT_ATTACHMENT.DELETE(contractId, attachmentId),
    {
      validate: {
        pathSegments: zodDeleteContractAttachmentEndpointSchema,
      },
      ...options,
    },
  );
};
